import { type CSSProperties, memo } from 'react';
import styled, { css } from 'styled-components';

import { Flex } from '../base';

const DataRowDataItem = (
  props: DataTableRowItemT & {
    style?: CSSProperties;
    fixed?: boolean;
    offset?: number;
    rowKey: string;
    isLastFixedIndex?: boolean;
  },
) => {
  return (
    <Style
      className="data-row-data-item text-sm"
      style={{
        width: props.width || 'auto',
        minWidth: props.width || 'auto',
        cursor: props.onCellClick ? 'pointer' : 'unset',
        padding: typeof props.children === 'string' ? '0px 8px' : undefined,
        ...props.style,
      }}
      fixed={props.fixed}
      offset={props.offset}
      isLastFixedIndex={props.isLastFixedIndex}
      onClick={props.onCellClick}
    >
      {props.children}
    </Style>
  );
};

type StyleProps = {
  fixed?: boolean;
  isLastFixedIndex?: boolean;
  offset?: number;
};

const Style = styled(Flex).attrs({ a: 'center' })<StyleProps>`
  height: 100%;
  padding-left: 8px;
  ${(props) =>
    props.fixed &&
    css`
      position: sticky;
      z-index: 1;
      left: ${props.offset || 0}px;
      background-color: ${(props) => props.theme.colors.gray100};
      ${props.isLastFixedIndex &&
      css`
        &::after {
          content: '';
          position: absolute;
          transform: translateX(100%);
          top: 0;
          right: 0;
          width: 24px;
          height: 100%;
          background: linear-gradient(
            to left,
            transparent,
            ${(props) => props.theme.colors.shadow_soft}
          );
        }
      `}
    `}
`;

export default memo(DataRowDataItem);
